import { createTheme, Theme } from '@mui/material';

import { globalTheme } from '../../../../../../../../../shared/theme/theme';

export const CampaignCarsExecutionProgressBarTheme: Theme = createTheme(
  globalTheme,
  {
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            '&.campaign-cars-execution-progress-bar-container': {
              boxShadow: 'unset',
              marginTop: '16px',
              '.campaign-cars-execution-progress-bar-box': {
                display: 'flex',
                flexDirection: 'column',
                width: '90%',
                marginBottom: '10px',
              },
              '.campaign-cars-execution-progress-bar': {
                marginRight: 1,
                marginBottom: '4px',
              },
              '.campaign-cars-execution-progress-bar-label': {
                display: 'flex',
                justifyContent: 'space-between',
              },
            },
          },
        },
      },
      MuiLinearProgress: {
        styleOverrides: {
          root: {
            height: '8.04px',
            backgroundColor: globalTheme.palette.appGrey.whiteSmoke,
            borderRadius: '16px',
          },
        },
      },

      MuiTypography: {
        styleOverrides: {
          root: {
            lineHeight: '16px',
            fontSize: '14px',
            marginTop: '4px',
            color: globalTheme.palette.appGrey.buttonBorder,
          },
        },
      },
    },
  }
);
